const SERVER_TIMEZONE = 'America/New_York';
const SERVER_DATETIME_PATTERN = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/;
const UNIX_TIMESTAMP_PATTERN = /^\d{10}(?:\d{3})?$/;
const serverDateTimeFormatter = new Intl.DateTimeFormat('en-US', {
	timeZone: SERVER_TIMEZONE,
	year: 'numeric',
	month: '2-digit',
	day: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
	second: '2-digit',
	hourCycle: 'h23',
});

function pad(value) {
    return String(value).padStart(2, '0');
}

function serverWallClockTimestamp(timestamp) {
	const parts = Object.fromEntries(serverDateTimeFormatter.formatToParts(new Date(timestamp))
		.filter((part) => part.type !== 'literal')
		.map((part) => [part.type, Number(part.value)]));
	return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
}

function serverDateTimeToDate(value) {
    const matched = String(value).trim().match(SERVER_DATETIME_PATTERN);
    if (!matched || matched[1] === '0000') return null;

    const parts = matched.slice(1).map(Number);
    const utcTimestamp = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]);
    const verificationDate = new Date(utcTimestamp);
    if (
        verificationDate.getUTCFullYear() !== parts[0]
        || verificationDate.getUTCMonth() !== parts[1] - 1
        || verificationDate.getUTCDate() !== parts[2]
        || verificationDate.getUTCHours() !== parts[3]
        || verificationDate.getUTCMinutes() !== parts[4]
        || verificationDate.getUTCSeconds() !== parts[5]
    ) {
        return null;
    }

	const dayMilliseconds = 24 * 60 * 60 * 1000;
	const offsets = [utcTimestamp, utcTimestamp - dayMilliseconds, utcTimestamp + dayMilliseconds]
		.map((timestamp) => serverWallClockTimestamp(timestamp) - timestamp);
	const candidates = offsets.map((offset) => utcTimestamp - offset).sort((first, second) => first - second);
	const matchingTimestamp = candidates.find((timestamp) => serverWallClockTimestamp(timestamp) === utcTimestamp);
	return matchingTimestamp === undefined ? null : new Date(matchingTimestamp);
}

function toDate(value) {
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
    if (typeof value === 'number' && Number.isFinite(value)) {
        return new Date(value >= 100000000000 ? value : value * 1000);
    }
    if (typeof value !== 'string') return null;

    const normalized = value.trim();
    if (!normalized) return null;
    if (UNIX_TIMESTAMP_PATTERN.test(normalized)) {
        const timestamp = Number(normalized);
        return new Date(normalized.length === 10 ? timestamp * 1000 : timestamp);
    }
	if (SERVER_DATETIME_PATTERN.test(normalized)) return serverDateTimeToDate(normalized);

    const parsed = new Date(normalized);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/**
 * Convert a server New York datetime or Unix timestamp to the browser's local time.
 */
export function formatRecordTime(value, fallback = '--') {
    const date = toDate(value);
    if (!date) return fallback;

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
